import { render } from "./WizardGT.vue?vue&type=template&id=04033667&scoped=true"
import script from "./WizardGT.vue?vue&type=script&lang=js"
export * from "./WizardGT.vue?vue&type=script&lang=js"

import "./WizardGT.vue?vue&type=style&index=0&id=04033667&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04033667"

export default script